module.exports = __webpack_public_path__ + "img/mondsee_kirche.bb966705.jpg";